jQuery(document).ready(function ($) {
  new WOW().init();

  ((g) => {
    var h,
      a,
      k,
      p = "The Google Maps JavaScript API",
      c = "google",
      l = "importLibrary",
      q = "__ib__",
      m = document,
      b = window;
    b = b[c] || (b[c] = {});
    var d = b.maps || (b.maps = {}),
      r = new Set(),
      e = new URLSearchParams(),
      u = () =>
        h ||
        (h = new Promise(async (f, n) => {
          await (a = m.createElement("script"));
          e.set("libraries", [...r] + "");
          for (k in g)
            e.set(
              k.replace(/[A-Z]/g, (t) => "_" + t[0].toLowerCase()),
              g[k]
            );
          e.set("callback", c + ".maps." + q);
          a.src = `https://maps.${c}apis.com/maps/api/js?` + e;
          d[q] = f;
          a.onerror = () => (h = n(Error(p + " could not load.")));
          a.nonce = m.querySelector("script[nonce]")?.nonce || "";
          m.head.append(a);
        }));
    d[l]
      ? console.warn(p + " only loads once. Ignoring:", g)
      : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
  })({ key: "AIzaSyBxnhTmjyI2EvkjRDIo49bBCojtRI8J0XQ", v: "weekly" });

  if ($("[data-swiper-slider]").length) {
    $("[data-swiper-slider]").each(function () {
      const self = $(this);
      const id = self.attr("id");
      const options = self.data("options");
      const breakpoint = self.data("break-point");
      const noSliderOnMobile = self.data("no-slider-on-mobile");
      const isCenter = self.data("is-center");

      if (self.data("number-paging")) {
        options.pagination = {
          ...(options.pagination || {}),
          renderBullet: function (index, className) {
            return `<span class="${className}">
              <span class="number">${index + 1}</span>
            </span>`;
          },
        };
      }

      if (!(noSliderOnMobile && $(window).width() <= breakpoint)) {
        const swiper = new Swiper(`#${id}`, {
          navigation: {
            nextEl: `#${id}-button-next`,
            prevEl: `#${id}-button-prev`,
          },
          ...options,
          on: {
            init: function () {
              if (isCenter) {
                setTimeout(function () {
                  if (
                    self.parent().find(".swiper-button-disabled").length ===
                      2 ||
                    ($(`#${id}-button-next`).hasClass(
                      "swiper-button-disabled"
                    ) &&
                      $(`${id}-button-prev`).hasClass("swiper-button-disabled"))
                  ) {
                    self
                      .find(".swiper-wrapper")
                      .addClass("justify-content-center");
                    self
                      .parent()
                      .find(`#${id}-pagination`)
                      .css({ display: "none" });
                  } else {
                    self
                      .find(".swiper-wrapper")
                      .removeClass("justify-content-center");
                    self.parent().find(`#${id}-pagination`).attr({ style: "" });
                  }
                }, 350);
              }
            },
            resize: function () {
              if (
                self.parent().find(".swiper-button-disabled").length === 2 &&
                isCenter
              ) {
                self.find(".swiper-wrapper").addClass("justify-content-center");
                self
                  .parent()
                  .find(`#${id}-pagination`)
                  .css({ display: "none" });
              } else {
                self
                  .find(".swiper-wrapper")
                  .removeClass("justify-content-center");
                self.parent().find(`#${id}-pagination`).attr({ style: "" });
              }
            },
          },
        });
      }
    });
  }

  if (
    $("[data-swiper-top-slider]").length &&
    $("[data-swiper-thumbs-slider]").length
  ) {
    const optionsThumbs = $("[data-swiper-thumbs-slider]").data("options");
    const swiperThumbs = new Swiper("[data-swiper-thumbs-slider]", {
      ...optionsThumbs,
    });

    const optionsTop = $("[data-swiper-top-slider]").data("options");
    const swiperTop = new Swiper("[data-swiper-top-slider]", {
      ...optionsTop,
      thumbs: {
        swiper: swiperThumbs,
      },
    });
  }

  $(window).on("resize", function () {
    const w = $(this).width();

    $("[data-swiper-slider]").each(function () {
      const self = $(this);
      const id = self.attr("id");
      const options = self.data("options");
      const breakpoint = self.data("break-point");
      const noSliderOnMobile = self.data("no-slider-on-mobile");

      const currentSwiper = document.getElementById(id).swiper;

      if (noSliderOnMobile & (w <= breakpoint)) {
        if (currentSwiper) {
          currentSwiper.destroy();
        }
      } else {
        if (w > breakpoint && !currentSwiper) {
          new Swiper(`#${id}`, {
            modules: [Navigation, Pagination],
            ...options,
          });
        }
      }
    });
  });

  $("[data-copy-text]").on("click", function (e) {
    e.preventDefault();
    const self = $(this);
    var copyText = self.text();

    self
      .closest("[data-copy-clipboard]")
      .find("[data-copied]")
      .removeClass("d-none");

    setTimeout(function () {
      self
        .closest("[data-copy-clipboard]")
        .find("[data-copied]")
        .addClass("d-none");
    }, 3000);

    navigator.clipboard.writeText(copyText);
  });

  $('[data-toggle-menu=""]').on("click", function () {
    const self = $(this);
    const header = self.closest("header");

    header.find("[data-header-menu]").toggleClass("opened");
    header.find("[data-overlay-fullscreen]").stop().fadeToggle();

    $("html, body").toggleClass("overflow-hidden");
  });

  $('[data-toggle-sub-menu=""]').on("click", function () {
    const self = $(this);
    self
      .closest("[data-parent-menu]")
      .find("[data-sub-menu]")
      .stop()
      .slideToggle();
  });

  // Product slider filter by category
  $("[data-product-categories] [data-category]").on("click", function (e) {
    e.preventDefault();
    const self = $(this);
    const categoryId = self.data("category");
    const prefixId = self.closest("[data-products]").data("products");

    if (
      prefixId &&
      categoryId &&
      $(`#${prefixId}_category_${categoryId}`).length
    ) {
      self.closest("[data-products]").find(".swiper").removeClass("active");

      $(`#${prefixId}_category_${categoryId}`).addClass("active");

      self
        .closest("[data-product-categories]")
        .find(".active")
        .removeClass("active");
      self.parent().addClass("active");
    }
  });

  // About histories
  if ($("[data-slick-histories]").length) {
    $("[data-slick-histories]").slick({
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      centerPadding: 0,
      swipeToSlide: false,
      swipe: false,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
            slidesToScroll: 1,
            infinite: true,
            centerMode: true,
            centerPadding: 36,
          },
        },
      ],
    });

    $(".histories-timeline li").on("click", function () {
      const self = $(this);
      $("[data-slick-histories]").slick("slickGoTo", self.index());
      const w = $(window).width();

      $(".histories-timeline li").removeClass("active");
      self.addClass("active");

      let spacingPadding = w > 767 ? 20 : 0;
      const spacingLeft =
        w -
        $(".wp-block--histories [data-row]").first().width() -
        spacingPadding;
      const wItem = w > 767 ? 160 : 80;
      $(".line")
        .stop()
        .animate({
          left: self.index() * wItem + spacingLeft,
        });
      self.parent().animate({
        scrollLeft: (self.index() - 1) * wItem + spacingLeft,
        behavior: "smooth",
      });
    });

    $(".histories-timeline li").eq(0).trigger("click");
  }

  $("[data-copy-clipboard]").on("click", function (e) {
    e.preventDefault();
    const self = $(this);
    const text = self.data("copy-clipboard");

    navigator.clipboard.writeText(text);
    self
      .find("[data-text]")
      .html(self.find("[data-text-copied]").data("text-copied"));

    setTimeout(function () {
      self
        .find("[data-text]")
        .html(self.find("[data-text-copy]").data("text-copy"));
    }, 3000);
  });

  $("[data-toggle-chat]").on("click", function () {
    const id = $(this).data("id");
    if ($(`#${id}`).length > 0) {
      $("body").toggleClass("opened");
      $(this).toggleClass("opened");
      $(`#${id}`).toggleClass("opened");
    }
  });

  // OEM
  var winX = null;
  var winY = null;

  window.addEventListener("scroll", function () {
    if (winX !== null && winY !== null) {
      window.scrollTo(winX, winY);
    }
  });

  // function disableWindowScroll() {
  //   winX = window.scrollX;
  //   winY = window.scrollY;
  // }

  // function enableWindowScroll() {
  //   winX = null;
  //   winY = null;
  // }

  // const OEMId = $(".oem").find(".swiper").attr("id");
  // const swiperOem = document.getElementById(OEMId)?.swiper;
  // if (swiperOem) {
  //   const slides = $(".oem").find(".swiper .swiper-slide").length + 1;

  //   $(window).on("scroll", function () {
  //     const scrollTop = $(this).scrollTop();
  //     const wH = $(".oem").height();
  //     const step = wH / slides;

  //     const idx =
  //       scrollTop / step > slides - 1 ? slides - 1 : parseInt(scrollTop / step);
  //     swiperOem.slideTo(idx);
  //   });

  //   swiperOem.on("slideChangeTransitionStart", function (s) {
  //     disableWindowScroll();
  //   });

  //   swiperOem.on("slideChangeTransitionEnd", function (s) {
  //     enableWindowScroll();
  //   });
  // }

  // Modal
  if ($("[data-modal]").length) {
    $("[data-modal]").on("click", function () {
      $($(this).data("modal")).modal({
        fadeDuration: 100,
      });
      return false;
    });

    $(".modal").on("hidden.bs.modal", function (e) {
      var iframes = $(e.target).find("iframe");
      iframes.each(function (index, iframe) {
        $(iframe).attr("src", $(iframe).attr("src"));
      });
    });
  }

  // Tabs
  $("[data-tab-controls] [data-target]").on("click", function () {
    const self = $(this);
    const target = self.data("target");

    if ($(`#${target}`).length) {
      const ele = $(`#${target}`);
      ele
        .closest("[data-tab-contents]")
        .find("[data-content].opened")
        .stop()
        .hide();

      ele.addClass("opened");
      ele.stop().show();

      self.closest("[data-tab-controls]").find(".active").removeClass("active");
      self.addClass("active");
    }
  });

  $("[data-tab-controls] .active").each(function () {
    const self = $(this);
    const target = self.data("target");

    if ($(`#${target}`).length) {
      const ele = $(`#${target}`);
      ele.addClass("opened");
      ele.stop().show();
    }
  });

  // Accordion
  $("[data-accordions] [data-accordion-control]").on("click", function () {
    const self = $(this);
    if (self.hasClass("active")) {
      self
        .closest("[data-accordion]")
        .find("[data-accordion-content].active")
        .stop()
        .slideUp();
      self
        .closest("[data-accordion]")
        .find("[data-accordion-control].active")
        .removeClass("active");
    } else {
      self
        .closest("[data-accordions]")
        .find("[data-accordion-content].active")
        .stop()
        .slideUp();
      self
        .closest("[data-accordions]")
        .find("[data-accordion-control].active")
        .removeClass("active");

      self
        .closest("[data-accordion]")
        .find("[data-accordion-content]")
        .stop()
        .slideDown();
      self
        .closest("[data-accordion]")
        .find("[data-accordion-content]")
        .addClass("active");
      self
        .closest("[data-accordion]")
        .find("[data-accordion-control]")
        .addClass("active");
    }
  });

  $("[data-select-links]").on("change", function (e) {
    e.preventDefault();

    if (e.target.value) {
      window.location.href = e.target.value;
    }
  });

  // Counter
  function visible(partial) {
    var $t = partial,
      $w = $(window),
      viewTop = $w.scrollTop(),
      viewBottom = viewTop + $w.height(),
      _top = $t.offset().top,
      _bottom = _top + $t.height(),
      compareTop = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return (
      compareBottom <= viewBottom && compareTop >= viewTop && $t.is(":visible")
    );
  }

  if ($(".count-digit").length && visible($(".count-digit"))) {
    if ($(".count-digit").hasClass("counter-loaded")) return;
    $(".count-digit").addClass("counter-loaded");

    $(".count-digit").each(function () {
      var $this = $(this);
      $({ Counter: 0 }).animate(
        { Counter: $this.text() },
        {
          duration: 2500,
          easing: "swing",
          step: function () {
            $this.text(Math.ceil(this.Counter));
          },
        }
      );
    });
  }

  // Slick
  if ($("[data-slick]").length) {
    $("[data-slick]").each(function () {
      const self = $(this);
      const options = self.data("slick");

      self.slick({
        ...options,
      });
    });
  }

  setTimeout(function () {
    $(window).trigger("resize");
  }, 150);

  // Search branches
  var map;
  var markers = [];

  async function initMap() {
    const { Map } = await window.google.maps.importLibrary("maps");

    map = new Map(document.getElementById("map"), {
      center: { lat: -34.397, lng: 150.644 },
      zoom: 16,
    });

    window.google.maps.event.addListenerOnce(
      map,
      "bounds_changed",
      function () {
        this.setZoom(16);
      }
    );
  }

  function addMarker(position) {
    const marker = new google.maps.Marker({
      position,
      map,
    });

    markers.push(marker);
  }

  // Sets the map on all markers in the array.
  function setMapOnAll(map) {
    for (let i = 0; i < markers.length; i++) {
      markers[i].setMap(map);
    }
  }

  // Removes the markers from the map, but keeps them in the array.
  function hideMarkers() {
    setMapOnAll(null);
  }

  // Shows any markers currently in the array.
  function showMarkers() {
    setMapOnAll(map);
  }

  // Deletes all markers in the array by removing references to them.
  function deleteMarkers() {
    hideMarkers();
    markers = [];
  }

  if ($("#map").length) {
    initMap();
  }

  // Stores
  function renderStores(data, eleStore) {
    const totalResults = eleStore.find("[data-total-results]");
    const results = eleStore.find("[data-results]");

    deleteMarkers();

    totalResults.html(data.length);

    let html = "";
    data.forEach((item) => {
      html += `
            <div class="item" data-branch="" data-branch-state="${
              item?.acf?.google_map?.state || ""
            }" data-lat="${item?.acf?.google_map?.lat || ""}" data-lng="${
        item?.acf?.google_map?.lng || ""
      }">
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"
                  class="item__icon">
                  <path
                    d="M18 2.625C24.825 2.625 30.375 8.25 30.375 15.075C30.375 19.275 28.125 23.4 24.45 27.375C23.175 28.725 21.825 29.925 20.475 31.05C20.025 31.425 19.575 31.8 19.125 32.025L18.9 32.175L18.6 32.4C18.225 32.625 17.7 32.625 17.325 32.4C17.25 32.325 17.175 32.25 17.025 32.175L16.575 31.875C16.275 31.65 15.9 31.35 15.525 31.05C14.175 29.925 12.825 28.725 11.55 27.375C7.875 23.475 5.625 19.275 5.625 15.075C5.625 8.25 11.175 2.625 18 2.625ZM18 10.5C15.75 10.5 13.875 12.375 13.875 14.625C13.875 16.875 15.75 18.75 18 18.75C20.25 18.75 22.125 16.875 22.125 14.625C22.125 12.375 20.25 10.5 18 10.5Z"
                    fill="#86BC24" />
                </svg>
                <div class="item__info">
                  <p class="item__title">${item?.title?.rendered || ""}</p>
                  <p class="item__address" data-address="">
                    ${item?.acf?.google_map?.address || ""}
                  </p>
                </div>
              </div>
            `;

      // Markers
      addMarker({
        lat: item?.acf?.google_map?.lat,
        lng: item?.acf?.google_map?.lng,
      });

      var bounds = new google.maps.LatLngBounds();
      var myLatLng = new google.maps.LatLng(
        item?.acf?.google_map?.lat,
        item?.acf?.google_map?.lng
      );
      bounds.extend(myLatLng);

      // Add a marker clusterer to manage the markers.
      new markerClusterer.MarkerClusterer({ markers, map });

      map.fitBounds(bounds);
      map.setZoom(16);
    });

    results.html(html);
  }

  let stores = [];
  let page = 1;
  let lastPage = false;
  if ($("[data-store]").length) {
    const store = $("[data-store]");
    const state = store.find("[data-state]");

    deleteMarkers();

    function getAllStores(page) {
      const ajaxUrl = store.data("ajax-url");
      $.ajax(`${ajaxUrl}?_fields=id,type,title,acf&per_page=100&page=${page}`, {
        dataType: "json",
        success: function (data, status, xhr) {
          stores = [...stores, ...data];

          const nextPage = page + 1;
          if (!lastPage) {
            page = nextPage;
            setTimeout(function () {
              getAllStores(nextPage);
            }, 150);
          }
        },
        error: function () {
          // If call API has error (rest_post_invalid_page_number), stop call to get more stores
          lastPage = true;

          renderStores(stores, store);

          let htmlState = `<option value="">${state.data(
            "placeholder"
          )}</option>`;
          const uniqueStoresByState = [
            ...new Set(
              stores
                .filter((item) => item?.acf?.google_map)
                .map((item) => item?.acf?.google_map?.state)
            ),
          ];
          uniqueStoresByState.forEach((item) => {
            htmlState += `<option value="${item}">${item}</option>`;
          });
          state.html(htmlState);
        },
      });
    }

    getAllStores(1);

    // Search store
    let debounce = null;
    $("[data-field]").on("change keyup", function () {
      const self = $(this);
      const form = self.closest("form");
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(function () {
        const arrayForm = form.serializeArray();
        const objForm = {};
        arrayForm.forEach(function (input) {
          objForm[input.name] = input.value;
        });

        filterStore(objForm, form.closest("[data-store]"));
      }, 350);
    });

    $("[data-filter]").on("submit", function (e) {
      e.preventDefault();
      const self = $(this);
      const arrayForm = self.serializeArray();
      const objForm = {};
      arrayForm.forEach(function (input) {
        objForm[input.name] = input.value;
      });

      filterStore(objForm, self.closest("[data-store]"));
    });

    function filterStore({ state, address }, eleStore) {
      const originStores = [...stores];
      let filteredStores = [];
      if (state && address) {
        filteredStores = originStores.filter((item) => {
          return (
            item?.acf?.google_map.state === state &&
            item?.acf?.google_map?.address.indexOf(address)
          );
        });
      } else if (state) {
        filteredStores = originStores.filter((item) => {
          return item?.acf?.google_map.state === state;
        });
      } else if (address) {
        filteredStores = originStores.filter((item) => {
          return (
            `${item?.acf?.google_map?.address}`
              .toLocaleLowerCase()
              .indexOf(`${address}`.toLocaleLowerCase()) !== -1
          );
        });
      } else {
        filteredStores = [...originStores];
      }

      renderStores(filteredStores, eleStore);
    }
  }

  function objectifyForm(formArray) {
    var returnArray = {};
    for (var i = 0; i < formArray.length; i++) {
      returnArray[formArray[i]["name"]] = formArray[i]["value"];
    }
    return returnArray;
  }

  $("[data-field]").on("change input", function () {
    const self = $(this);
    const form = self.closest("form");
    const store = self.closest("[data-store]");
    const results = store.find("[data-results]");
    const { state, address } = objectifyForm(form.serializeArray());

    results.find("[data-branch]").each(function () {
      const branch = $(this);
      branch.addClass("d-none");

      if (!state && !address) {
        branch.removeClass("d-none");
      } else {
        if (state && address) {
          if (
            branch.data("branch-state") === state &&
            branch.find("[data-address]").html().indexOf(address) !== -1
          ) {
            branch.removeClass("d-none");
          }
        } else if (state) {
          if (branch.data("branch-state") === state) {
            branch.removeClass("d-none");
          }
        } else {
          if (branch.find("[data-address]").html().indexOf(address) !== -1) {
            branch.removeClass("d-none");
          }
        }
      }
    });

    store
      .find("[data-total-results]")
      .html(results.find(`[data-branch]:not(".d-none")`).length);
  });

  $(document).on("click", "[data-branch]", function () {
    const self = $(this);
    const lat = self.data("lat");
    const lng = self.data("lng");
    if (map) {
      const latLng = new window.google.maps.LatLng(lat, lng);
      map.panTo(latLng);
    }
  });

  var lastScrollTop = 0;
  $(window).scroll(function (event) {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
      $("body").addClass("scroll-down");
      $("body").removeClass("scroll-up");
    } else {
      $("body").removeClass("scroll-down");
      $("body").addClass("scroll-up");
    }
    lastScrollTop = st;
  });

  // Dropdown
  $('[data-toggle="dropdown"]').on("click", function (e) {
    e.preventDefault();
    const self = $(this);
    const href = self.attr("href");

    if (self.data("hover")) return;

    const dropdownContent = self.next("[data-dropdown-content]");

    if (dropdownContent.length) {
      self.parent().toggleClass("opened");
      self.toggleClass("opened");
      dropdownContent.toggleClass("opened");
      dropdownContent.stop().slideToggle();
    }
  });

  $(document).mouseup(function (e) {
    $('[data-toggle="dropdown"]').each(function () {
      const container = $(this);

      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if (container.hasClass("opened")) {
          container.trigger("click");
        }
      }
    });
  });
  // End of Dropdown

  if ($(".masonry-grid").length) {
    $(".masonry-grid").masonry({
      columnWidth: ".grid-item",
      gutter: ".gutter-sizer",
      percentPosition: true,
      horizontalOrder: true,
      fitWidth: true,
    });
  }

  if ($("[data-photo-swipe]").length) {
    $.getScript(
      "https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.2/umd/photoswipe-lightbox.umd.min.js",
      function () {
        $.getScript(
          "https://cdnjs.cloudflare.com/ajax/libs/photoswipe/5.4.2/umd/photoswipe.umd.min.js",
          function () {
            const lightbox = new PhotoSwipeLightbox({
              gallery: `[data-photo-swipe=""]`,
              children: "a",
              pswpModule: PhotoSwipe,
            });

            lightbox.init();
          }
        );
      }
    );
  }

  if ($(".parallax-window").length) {
    $(".parallax-window").each(function () {
      const self = $(this);
      self.parallax({ imageSrc: self.data("image-src") });
    });
  }



  $('[data-parent-menu] a').on('click', function (e) {
    const href = $(this).attr('href');
    const hash = href.includes('#') ? href.split('#')[1] : '';

    const header = $(this).closest('header');
    const menu = header.find('[data-header-menu]');

    if (menu) {
        menuIsOpen = false; 
        menu.removeClass('opened');
        const overlay = header.find('[data-overlay-fullscreen]');
        overlay.fadeOut();
    }

    if (hash && $('#' + hash).length) {
        e.preventDefault();
        history.pushState(null, '', href);
        $('html, body').animate({ scrollTop: $('#' + hash).offset().top }, 2000, function () {
            $('html, body').removeClass('overflow-hidden');
        });
    } else {
        window.location.href = href;
    }
});

  
});
